import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleDuration, handleVoiceAudioTime } from "redux/counterSlice";

interface TranscriptType {
  blackListedWords: string[]
}

const Transcript = ({ usersTranscript, blackListedWords }: any) => {

  const voiceAudioTime = useSelector((state: any) => state.counter.voiceAudioTime);
  const dispatch = useDispatch();
  const temp = blackListedWords?.map((i: any) => i?.word?.toLowerCase());

  const borderClass = (i: any) => {
    if (i.sentiment === "Neutral") {
      return " border border-primary border-4 border-top-0 border-end-0 border-bottom-0 mb-4 pl-2 cursor-pointer"
    } else if (i.sentiment === "Negative") {
      return " border border-danger border-4 border-top-0 border-end-0 border-bottom-0 mb-4 pl-2 cursor-pointer"
    } else if (i.sentiment === "Positive") {
      return " border border-success border-4 border-top-0 border-end-0 border-bottom-0 mb-4 pl-2 cursor-pointer"
    }
  }


  const HighlightedParagraph = (paragraph: string) => {
    // Split the paragraph into an array of words
    const words: any = paragraph.split(' ');

    // Apply styling to the words to highlight
    const highlightedWords = words.map((word: string, index: string) => {
      const isHighlighted = temp?.includes(word.toLowerCase().replace(/[^\w\s]/gi, ''));
      return isHighlighted ? (
        <span key={index} className="fw-medium" style={{ color: "#FF5155" }}>
          {word}
        </span>
      ) : (
        <>
          {" "}{word}{" "}
        </>
      );
    });

    return highlightedWords;
  };

  const HighlightSantance = (paragraph: string) => {
    const senToFound = usersTranscript.anticipation_strings;

    // const highlightedSen = senToFound.map(((rt: any) => {
    //   if (paragraph.toLowerCase().includes(rt)) {
    //     return <span style={{ color: "#3B82F6" }}>{paragraph}
    //     </span>
    //   } else {
    //     return paragraph
    //   }
    // }))

    const highlightedSen = senToFound.map((targetSentence: string) => {
      const foundSentence = paragraph.toLowerCase().includes(targetSentence);
      // return foundSentence ? <span style={{ color: "#3B82F6" }}>{paragraph}</span> : paragraph;
      return foundSentence
    })
    const temp = highlightedSen.some((value: boolean) => value === true)
    return temp ? <span style={{ color: "#505AD6" }}>{HighlightedParagraph(paragraph)}</span> : HighlightedParagraph(paragraph);
  }


  const handleClick = (duration: string) => {
    // const [hours, minutes, seconds] = duration.split(':').map(Number);
    // return hours * 3600 + minutes * 60 + seconds;
    const [minutes, seconds] = duration.split(':').map(Number);
    const timeToSeconds = minutes * 60 + seconds;
    dispatch(handleDuration(timeToSeconds))
  }

  const listRefs: any = useRef([]);

  useEffect(() => {
    // Slice the refs array to match the length of the output_text array
    listRefs.current = listRefs.current.slice(0, usersTranscript?.response?.output_text?.length);
    // Scroll to the top immediately when usersTranscript changes
    if (listRefs.current.length > 0) {
      const firstRef = listRefs.current[0];
      if (firstRef) {
        firstRef.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Add MutationObserver to each list item
    listRefs.current.forEach((ref: any, index: number) => {
      if (ref) {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              if (ref.classList.contains('section-message')) {
                ref.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        });
 
        observer.observe(ref, { attributes: true });
 
        return () => {
          observer.disconnect();
        };
      }
    });
  }, [usersTranscript]);

  return (
    <>
      <div className="text-end me-3 text-xs flex align-items-center justify-content-end">
      </div>
      <div className="section-transcript overflow-y-auto">
        {usersTranscript?.response?.output_text?.map((i: any, index: number) => (

          // <div key={index} className={`${borderClass(i)} section-user`} onClick={() => { handleClick(i.duration); dispatch(handleVoiceAudioTime(i.duration)) }}>
          <div key={index} ref={(el) => (listRefs.current[index] = el)} className={`${borderClass(i)} lists ${voiceAudioTime >= i.duration ? "section-message" : "section-user"}`} onClick={() => { handleClick(i.duration); dispatch(handleVoiceAudioTime(i.duration)) }}>
            {/* <p className='d-flex ps-1 mb-0 text-muted'>
              <span className='me-2 section-time'>{i.duration}</span> 
              <span className='section-user'>{i.user}</span>
            </p> */}
            <p className={`ps-1 fw-medium mb-0 text-sm  `}>{i.message && HighlightSantance(i.message)}</p>
            {/* <p className='ps-1 fw-medium mb-0 text-sm section-message'>{i.message && HighlightSantance(i.message)}</p> */}
          </div>
        ))}
      </div>
    </>
  )
}

export default Transcript